// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, react/destructuring-assignment */
import React from "react"
import Close from "@kiwicom/orbit-components/lib/icons/Close"
import { FormattedMessage } from "react-intl"

type Props = {
  onClose: () => void
  title: string
  store: string
  link: string
  onClick?: () => void
}

const MobileAdComponent = (props: Props) => (
  <div className="MobileAd">
    <span className="MobileAd-close" onClick={props.onClose}>
      <Close ariaHidden />
    </span>
    <span className="MobileAd-content">
      <img className="MobileAd-content-image" src="/images/about/app-logo.png" alt="" />
      <span className="MobileAd-content-text">
        <span className="MobileAd-content-text-title">{props.title}</span>
        <span>Kiwi.com s.r.o.</span>
        {props.store}
      </span>
    </span>

    <div className="MobileAd-button-wrapper">
      <a className="MobileAd-button spBtn" href={props.link} onClick={props.onClick}>
        <FormattedMessage id="common.download" defaultMessage="Download" />
      </a>
    </div>
  </div>
)

export default MobileAdComponent
